import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation, input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Size } from '../../../contract/size.contract';

@Component({
  selector: 'osp-spinner',
  standalone: true,
  imports: [ProgressSpinnerModule, NgClass],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SpinnerComponent {
  @HostBinding('class.osp-spinner') protected hostCssClassEnabled = true;
  size = input<Size>('medium');
}
